import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon, MDBBadge  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip, Spin  } from 'antd';
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import Modalusercommentbacktbn from './Modalusercommentbacktbn';
import Modalusercommentbacktex from './Modalusercommentbacktex';
import { URL,api } from '../api';
import Modalshowevaluation from './Modalshowevaluation';
import Modaluseredittorob2 from './Modaluseredittorob2';

//import Modalexpercommentbacktbn from './Modalexpercommentbacktbn';


export default class Commentexlistforuser extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",
   id_send:"",
   expert_id:'',
   iduser:'',
   commentuser:[],
   url:'https://mua.kpru.ac.th/FrontEnd_Kprupsf/',
  
   
}


//this.handleSubmit = this.handleSubmit.bind(this);

this.toggle = this.toggle.bind(this);
this.list = this.list.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.getExpert()
;  this.props.selectex();
}


 componentDidMount() {
    //   const { id_send } = this.props.id_send
    //   console.log(id_send);
       this.setState({ id_send:this.props.id_send,
                       iduser:this.props.iduser,
         })
      setTimeout(() => {
        api.get('registercon/Selectarticpsfbnback2/'+this.props.id_emp+'/'+this.props.id_articlepsf)
        .then(res => {
          console.log(res);
          this.setState({ commentuser: res.data})
         
        }) 
      }, 0);

  }


  list() {
      setTimeout(() => {
        api.get('registercon/Selectarticpsfbnback2/'+this.props.id_emp+'/'+this.props.id_articlepsf)
        .then(res => {
          console.log(res);
          this.setState({ commentuser: res.data})
        
        }) 
      }, 0);
  }



    render() {
      //  console.log(this.state.id_bn)

        return (
            <>
          
     
{this.state.commentuser.length === 0 ?<>
<div className='text-center'><p>อยู่ระหว่างดำเนินการ</p></div>
</>:<>

 <MDBTable bordered responsive>
 <MDBTableHead color="blue-grey lighten-3" textWhite>
        <tr>
          <th>ลำดับ</th>
          <th>ไฟล์ข้อเสนอแนะของกรรมการ </th>
          <th>ข้อเสนอแนะ</th>
          <th>ส่งกลับหลังปรับแก้ไข</th>
        
        </tr>
      </MDBTableHead>

      <MDBTableBody>
                          {this.state.commentuser.map((commentuser,index )  => 
                            <tr>
                            <td>{index+1}</td>
                            <td>{commentuser.send_uploadcommentepdfbn2 !== null ? <>
                            <a href={`${this.state.url+commentuser.send_uploadcommentepdfbn2	}`}  target="_blank"><spin className="green-text"><MDBIcon far icon="file-word" /> ไฟล์ข้อเสนอแนะของกรรมการ</spin> </a>
                            
                            </>:<>
                                {commentuser.statusbn2 === '1' || commentuser.statusbn2 === '2' ?<> 
                               <MDBBadge pill  color="success" >ผลงานปรับแก้ไข</MDBBadge> 
                               <a href={`${this.state.url+commentuser.send_uploadewordbn2}`}  target="_blank"><p className="blue-text"><MDBIcon far icon="file-word" /> word</p> </a>
                               <a href={`${this.state.url+commentuser.send_uploadepdfbn2}`}  target="_blank"><p className="red-text"><MDBIcon far icon="file-pdf" /> pdf</p> </a>
                                </>:<>  <MDBIcon far icon="hourglass" /></>}
                          
                            
                            </>}</td>
                            <td>{ commentuser.statusbn2 === '1' || commentuser.statusbn2 === '2' ?<>
                             {/* <MDBIcon far icon="hourglass" /> */}-
                             </>:<>{commentuser.bn_commentbn2} </>  }</td>

                            <td>
                          {commentuser.statusbn2 === '1' || commentuser.statusbn2 === '2' ? <> 
                          {/* <MDBIcon far icon="hourglass" /> */}-
                          </>:<>
{commentuser.statusbn2 === '3' ?<>
 <Modaluseredittorob2  id_articlepsf2={commentuser.id_articlepsf2} id_empbn2={commentuser.id_empbn2} nameuserbn2={commentuser.nameuserbn2} list={this.list} />
</>:<>
ส่งกลับแล้ว
</>}
                          
                          </>}
                              
                    
                            </td>
                          
                                  {/* <Modalexpercommentbacktbn id_send={commentbn.id_send} id_comment={commentbn.id_comment} id_bn={commentbn.id_bn} list={this.list}  /> */}
                             
                            </tr>
                          )}
          
          </MDBTableBody>
    </MDBTable>

</>}
   

   
           
          </>
          
        )
    }
}


